import { createContext } from "react";
import ClientOrdersStore from "./index";

const store = new ClientOrdersStore();
const ClientOrdersStoreContext = createContext<ClientOrdersStore>(store);
export default ClientOrdersStoreContext;
